import { ajax } from '@tencent/qd-lib';
import loginPanel from './loginCommon';
const gateway = (methodName, transParams) => {
    const request = (url, postData = {}, config = {}) => new Promise((resolve, reject) => {
        const reqData = postData && { ...postData };
        const { originRes, errLevel = 0 } = config || {};
        if (transParams) {
            reqData.params = postData;
        }
        ajax[methodName](url, reqData, { nopermission: loginPanel })
            .then((res) => {
                const { code, message, data } = res || {};

                if (originRes) {
                    resolve(res);
                } else {
                    if (parseInt(code, 10) === 0) {
                        resolve(data);
                    } else {
                        if (errLevel === 1) {
                            reject(res);
                        } else {
                            reject(message);
                        }
                    }
                }
            })
            .catch((err) => {
                if (originRes) {
                    reject(err);
                } else {
                    const { message } = err || {};
                    if (errLevel === 1) {
                        reject(err);
                    } else {
                        reject(message);
                    }
                }
            });
    });
    return request;
};

export default {
    get: gateway('gatewayGet', true),
    post: gateway('gatewayPost'),
};
